{
  "en": {
    "pcAtRecovery": {
      "submissionError": "Failed to submit PC/AT recovery request",
      "submissionSuccess": "PC/AT analysis started. Permit fields will be updated automatically.",
      "completionError": "PC/AT analysis failed. Please try again.",
      "noDocumentsSelected": "Please select a document",
      "singleDocumentRequired": "Please select exactly one document"
    }
  },
  "fr": {
    "pcAtRecovery": {
      "submissionError": "Échec de l'envoi de la requête de récupération PC/AT",
      "submissionSuccess": "Analyse PC/AT lancée. Les champs permis seront mis à jour automatiquement.",
      "completionError": "L'analyse PC/AT a échoué. Veuillez réessayer.",
      "noDocumentsSelected": "Veuillez sélectionner un document",
      "singleDocumentRequired": "Veuillez sélectionner exactement un document"
    }
  },
  "nl": {
    "pcAtRecovery": {
      "submissionError": "Fout bij het indienen van het PC/AT-herstelverzoek",
      "submissionSuccess": "PC/AT-analyse gestart. De vergunningsvelden worden automatisch bijgewerkt.",
      "completionError": "PC/AT-analyse mislukt. Probeer het opnieuw.",
      "noDocumentsSelected": "Selecteer alstublieft een document",
      "singleDocumentRequired": "Selecteer alstublieft exact één document"
    }
  }
}
